import {
  Box,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check-outlined-colored.svg";
import { ReactComponent as BonusIcon } from "../../../assets/icons/bonus.svg";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { CancelOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useRequest } from "../../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../../api/APIs";
import { useSnackBar } from "../../../context/SnackBarContext";
import { ReactComponent as ReferralBg } from "../../../assets/images/refferal-bg.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/copy.svg";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { ReactComponent as InviteFriendsIcon } from "../../../assets/icons/invite-friends.svg";
import { ReactComponent as QuestionMarkIcon } from "../../../assets/icons/question-mark.svg";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import IconRowWithArrow from "../../../components/shared/IconRowWithArrow";
import { ReferralRuleDrawer } from "./ReferralRules";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";
import CustomTextSkeleton from "../../../components/shared/CustomTextSkeleton";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";

function ProfileReferralPage() {
  const navigate = useNavigate();
  const openSnack = useSnackBar();
  const [successCode, setSuccessCode] = useState(false);
  const [code, setCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const { loading, apiCall: sendReferralCode } = useRequest(
    BalootUserV2APIs.postReferralCode
  );
  const [ruleOpen, setRuleOpen] = useState(false);
  const {
    dataLoading,
    apiCall: campaignReferral,
    result,
  } = useRequest(BalootUserV2APIs.getCampaignReferral, true);
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    navigator.clipboard.writeText(result?.code);
    setOpen(true);
    setTimeout(() => {
      handleTooltipClose();
    }, 1000);
  };

  useEffect(() => {
    campaignReferral();
  }, []);

  const handleClick = () => {
    sendReferralCode({
      data: { referralCode: code.toUpperCase() },
      onSuccess: () => {
        setSuccessCode(true);
      },
      onError: (error) => {
        if (error.status === 400) {
          setErrorMsg(error.message);
        } else {
          openSnack(true, { message: error.message });
        }
      },
    });
  };

  const handleSharing = async () => {
    if (navigator.share) {
      try {
        await navigator
          .share({
            title: "دعوت به بلوط",
            text: result.inviteMessage,
          })
          .then(() =>
            console.log("Hooray! Your content was shared to tha world")
          );
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      // fallback code
      console.log(
        "Web share is currently not supported on this browser. Please provide a callback"
      );
    }
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            دعوت از دوستان
          </Typography>
        }
        leftElement={
          result?.campaign?.id ? (
            <QuestionMarkIcon
              sx={{ color: "common.white" }}
              onClick={() => setRuleOpen(true)}
            />
          ) : (
            <></>
          )
        }
      />

      <Box
        sx={{
          overflow: "auto",
          flex: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%", minHeight: 300 }}></Box>
        <PageContentContainer
          sx={{
            display: "block",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            pb: `calc(env(safe-area-inset-bottom) + 100px )`,
          }}
        >
          <Box
            sx={{
              mt: -40,
              bgcolor: "common.white",
              width: "100%",
              px: "24px",
              py: "16px",
              borderRadius: "12px",
              boxShadow: (theme) => theme.shadows[3],
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <ReferralBg width={182} height={170} />
            </Box>

            {dataLoading || !result ? (
              <>
                <CustomTextSkeleton width={100} sx={{ margin: " 0 auto;" }} />
                <CustomRectangularSkeleton sx={{ mt: 2 }} height={40} />
                <CustomTextSkeleton width={100} sx={{ margin: "10px auto;" }} />
                <CustomTextSkeleton width={100} sx={{ margin: "10px auto;" }} />
              </>
            ) : (
              result && (
                <>
                  <Typography
                    mt={3}
                    variant="h5"
                    color="grey.2"
                    align="center"
                    fontSize="16px"
                    px={2}
                  >
                    {result?.campaign.title}
                  </Typography>

                  <Typography
                    mt={3}
                    mb={2}
                    variant="body2"
                    color="grey.2"
                    align="center"
                    px={2}
                  >
                    {result?.campaign.description}
                  </Typography>

                  <ClickAwayListener onClickAway={handleTooltipClose}>
                    <Tooltip
                      placement="top"
                      PopperProps={{
                        disablePortal: true,
                      }}
                      onClose={handleTooltipClose}
                      open={open}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      title="کپی شد"
                    >
                      <Box
                        onClick={handleTooltipOpen}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CopyIcon width={24} height={24} />

                        <Typography
                          variant="body2"
                          color="purple.1"
                          align="center"
                          fontSize="16px"
                          px={2}
                          mt={0.5}
                        >
                          {result?.code}
                        </Typography>
                      </Box>
                    </Tooltip>
                  </ClickAwayListener>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 3,
                    }}
                  >
                    <LoadingButton
                      onClick={handleSharing}
                      variant="contained"
                      sx={{
                        color: "common.white",
                        typography: "h5",
                        bgcolor: "purple.1",
                        "&:hover": {
                          bgcolor: "purple.2",
                        },
                      }}
                      size="small"
                    >
                      دوستتو دعوت کن
                    </LoadingButton>
                  </Box>

                  <ReferralRuleDrawer
                    campaignId={result?.campaign.id}
                    open={ruleOpen}
                    setOpen={setRuleOpen}
                  />
                </>
              )
            )}
          </Box>

          {result && result?.campaign && (
            <>
              {!result?.codeUsed && (
                <Box
                  sx={{
                    mt: 3,
                    bgcolor: "common.white",
                    width: "100%",
                    px: "16px",
                    py: "16px",
                    borderRadius: "12px",
                    boxShadow: (theme) => theme.shadows[3],
                  }}
                >
                  {successCode ? (
                    <>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <CheckIcon width={20} height={22} />
                        <Typography ml={1} variant="h4" color="grey.2">
                          کد معرف با موفقیت ثبت شد{" "}
                        </Typography>
                      </Box>
                      <Typography mt={2} variant="body2" color="grey.3">
                        چنانچه مراحل گفته شده را با موفقیت طی کنید مبلغ جایزه را
                        جهت سرمایه‌گذاری در بلوط دریافت خواهید کرد!
                      </Typography>

                      <Box
                        mb={0.5}
                        mt={0.5}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Typography
                          variant="h5"
                          color="primary.main"
                          mr={0.5}
                          onClick={() => setRuleOpen(true)}
                        >
                          مشاهده‌ی شرایط
                        </Typography>
                        <KeyboardArrowLeftIcon
                          width={24}
                          height={24}
                          sx={{
                            color: "primary.main",
                          }}
                        />
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mt: 0,
                        }}
                      >
                        <BonusIcon width={24} height={24} />
                        <Typography ml={1} variant="h4" color="grey.2">
                          کد معرف
                        </Typography>
                      </Box>
                      <TextField
                        error={Boolean(errorMsg)}
                        helperText={errorMsg}
                        placeholder={"کد معرف خود را وارد کنید"}
                        inputProps={{
                          maxLength: 6,
                          style: { textTransform: "uppercase" },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {code.length > 0 && (
                                  <IconButton
                                    onClick={() => {
                                      setErrorMsg("");
                                      setCode("");
                                    }}
                                  >
                                    <CancelOutlined sx={{ fontSize: 20 }} />
                                  </IconButton>
                                )}
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                        value={code}
                        onChange={(event) => {
                          setErrorMsg("");
                          if (event.target.value === null) {
                            setCode("");
                          } else {
                            setCode(event.target.value);
                          }
                        }}
                        sx={{ mt: "12px", direction: "ltr" }}
                        fullWidth
                      />
                      {/* </CacheProvider> */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 4,
                        }}
                      >
                        <LoadingButton
                          onClick={handleClick}
                          loading={loading}
                          disabled={code.length < 6}
                          variant="contained"
                          sx={{
                            color: "common.white",
                            typography: "h5",
                            width: 94,
                          }}
                          size="small"
                        >
                          تایید
                        </LoadingButton>
                      </Box>
                    </>
                  )}
                </Box>
              )}
            </>
          )}
          <BottomFullWidthButtonContainer
            sx={{
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }}
          >
            {dataLoading || !result ? (
              <CustomRectangularSkeleton height={40} />
            ) : (
              <IconRowWithArrow
                title={"تاریخچه دعوت از دوستان"}
                icon={InviteFriendsIcon}
                iconColor={"grey.4"}
                onClick={() =>
                  navigate(
                    `/app/profile/referral-history/${result?.campaign.id}`,
                    {
                      state: { inviteMessage: result.inviteMessage },
                    }
                  )
                }
              />
            )}
          </BottomFullWidthButtonContainer>
        </PageContentContainer>
      </Box>
    </>
  );
}

export default ProfileReferralPage;
